"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Modal = _interopRequireDefault(require("reactstrap/lib/Modal"));

var _ModalHeader = _interopRequireDefault(require("reactstrap/lib/ModalHeader"));

var _ModalBody = _interopRequireDefault(require("reactstrap/lib/ModalBody"));

var _ModalFooter = _interopRequireDefault(require("reactstrap/lib/ModalFooter"));

var _utils = require("../lib/utils");

var _button = _interopRequireDefault(require("../button/button"));

var _input = _interopRequireDefault(require("../input/input"));

var _label = _interopRequireDefault(require("../label/label"));

var _inputFeedback = _interopRequireDefault(require("../inputFeedback/inputFeedback"));

var _modalUtils = require("../lib/modalUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ConfirmationModal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ConfirmationModal, _React$Component);

  var _super = _createSuper(ConfirmationModal);

  function ConfirmationModal(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ConfirmationModal);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onModalOpen", function () {
      var onOpened = _this.props.onOpened;
      (0, _modalUtils.handleIERenderingIssues)(_this.ref.current);

      if ((0, _utils.isFunction)(onOpened)) {
        onOpened();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onModalClose", function () {
      var _this$props = _this.props,
          confirmReasonRequired = _this$props.confirmReasonRequired,
          emptyReasonError = _this$props.emptyReasonError,
          onClosed = _this$props.onClosed;

      if (confirmReasonRequired) {
        _this.setState({
          reasonInputValue: "",
          isReasonInputTouched: false,
          isReasonInputInvalid: true,
          invalidReasonErrorMessage: emptyReasonError
        });
      }

      if ((0, _utils.isFunction)(onClosed)) {
        onClosed();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleReasonChange", function (e) {
      var inputValue = e.target.value;

      var invalidReasonErrorMessage = _this.getInvalidReasonErrorMessage(inputValue);

      _this.setState({
        reasonInputValue: e.target.value,
        isReasonInputInvalid: invalidReasonErrorMessage !== null,
        invalidReasonErrorMessage: invalidReasonErrorMessage
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleReasonBlur", function () {
      var confirmReasonRequired = _this.props.confirmReasonRequired;

      if (confirmReasonRequired) {
        _this.setState({
          isReasonInputTouched: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getInvalidReasonErrorMessage", function (value) {
      var _this$props2 = _this.props,
          reasonMinLength = _this$props2.reasonMinLength,
          reasonMaxLength = _this$props2.reasonMaxLength,
          emptyReasonError = _this$props2.emptyReasonError,
          invalidReasonLengthError = _this$props2.invalidReasonLengthError,
          reasonRegex = _this$props2.reasonRegex,
          reasonRegexError = _this$props2.reasonRegexError;
      var trimValue = (0, _trim["default"])(value).call(value);

      if (trimValue === "") {
        return emptyReasonError;
      }

      if (reasonRegex && reasonRegexError && !reasonRegex.test(trimValue)) {
        return reasonRegexError;
      }

      if (trimValue.length < reasonMinLength || trimValue.length > reasonMaxLength) {
        return invalidReasonLengthError;
      }

      return null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleContinue", function (e) {
      var _this$props3 = _this.props,
          onContinue = _this$props3.onContinue,
          confirmReasonRequired = _this$props3.confirmReasonRequired;
      var reasonText = null;

      if (confirmReasonRequired) {
        var reasonInputValue = _this.state.reasonInputValue;

        var invalidReasonErrorMessage = _this.getInvalidReasonErrorMessage(reasonInputValue);

        if (invalidReasonErrorMessage !== null) {
          _this.setState({
            invalidReasonErrorMessage: invalidReasonErrorMessage,
            isReasonInputTouched: true,
            isReasonInputInvalid: true
          });

          return;
        }

        reasonText = reasonInputValue;
      }

      if ((0, _utils.isFunction)(onContinue)) {
        onContinue(e, reasonText);
      }
    });
    var _emptyReasonError = props.emptyReasonError,
        _confirmReasonRequired = props.confirmReasonRequired;
    _this.ref = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      reasonInputValue: "",
      isReasonInputTouched: false,
      isReasonInputInvalid: !!_confirmReasonRequired,
      invalidReasonErrorMessage: _emptyReasonError
    };
    return _this;
  }

  (0, _createClass2["default"])(ConfirmationModal, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          header = _this$props4.header,
          toggle = _this$props4.toggle,
          message = _this$props4.message,
          secondaryMessage = _this$props4.secondaryMessage,
          cancelButtonText = _this$props4.cancelButtonText,
          continueButtonText = _this$props4.continueButtonText,
          continueButtonType = _this$props4.continueButtonType,
          dataTestId = _this$props4.dataTestId,
          closeOnEscape = _this$props4.closeOnEscape,
          bodyClassName = _this$props4.bodyClassName,
          body = _this$props4.body,
          confirmReasonRequired = _this$props4.confirmReasonRequired,
          reasonLabel = _this$props4.reasonLabel,
          reasonPlaceholder = _this$props4.reasonPlaceholder;
      var _this$state = this.state,
          reasonInputValue = _this$state.reasonInputValue,
          invalidReasonErrorMessage = _this$state.invalidReasonErrorMessage,
          isReasonInputTouched = _this$state.isReasonInputTouched,
          isReasonInputInvalid = _this$state.isReasonInputInvalid;
      return /*#__PURE__*/_react["default"].createElement(_Modal["default"], (0, _extends2["default"])({
        "data-testid": dataTestId,
        innerRef: this.ref,
        centered: true,
        className: (0, _utils.gatherClasses)(this.props, "confirmation-modal"),
        keyboard: closeOnEscape
      }, (0, _utils.gatherConditionalProps)(this.props, "isOpen", "size", "autoFocus", "backdrop", "toggle", "onClosed"), {
        onOpened: this.onModalOpen,
        onClosed: this.onModalClose
      }), header && /*#__PURE__*/_react["default"].createElement(_ModalHeader["default"], {
        toggle: toggle
      }, header), /*#__PURE__*/_react["default"].createElement(_ModalBody["default"], {
        className: bodyClassName
      }, (0, _utils.isFunction)(body) ? body() : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        "aria-label": message
      }, message), secondaryMessage && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("div", null, secondaryMessage))), confirmReasonRequired && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_label["default"], {
        text: reasonLabel,
        className: "oui-mt-3",
        muted: true
      }), /*#__PURE__*/_react["default"].createElement(_input["default"], {
        type: "textarea",
        value: reasonInputValue,
        placeholder: reasonPlaceholder,
        onChange: this.handleReasonChange,
        onBlur: this.handleReasonBlur,
        isInvalid: isReasonInputInvalid && isReasonInputTouched
      }), isReasonInputInvalid && isReasonInputTouched && /*#__PURE__*/_react["default"].createElement(_inputFeedback["default"], {
        show: true,
        message: invalidReasonErrorMessage
      }))), /*#__PURE__*/_react["default"].createElement(_ModalFooter["default"], null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
        label: cancelButtonText,
        onClick: toggle
      }), /*#__PURE__*/_react["default"].createElement(_button["default"], {
        label: continueButtonText,
        onClick: this.handleContinue,
        type: continueButtonType,
        disabled: confirmReasonRequired && isReasonInputInvalid && isReasonInputTouched
      })));
    }
  }]);
  return ConfirmationModal;
}(_react["default"].Component);

ConfirmationModal.propTypes = {
  isOpen: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  closeOnEscape: _propTypes["default"].bool,
  body: _propTypes["default"].func,
  message: _propTypes["default"].string,
  secondaryMessage: _propTypes["default"].string,
  cancelButtonText: _propTypes["default"].string,
  continueButtonText: _propTypes["default"].string,
  className: _propTypes["default"].string,
  bodyClassName: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(["lg", "md", "sm"]),
  onContinue: _propTypes["default"].func.isRequired,
  toggle: _propTypes["default"].func.isRequired,
  onOpened: _propTypes["default"].func,
  onClosed: _propTypes["default"].func,
  continueButtonType: _propTypes["default"].oneOf(["primary", "danger"]),
  dataTestId: _propTypes["default"].string,
  backdrop: _propTypes["default"].string,
  confirmReasonRequired: _propTypes["default"].bool,
  reasonLabel: _propTypes["default"].string,
  reasonPlaceholder: _propTypes["default"].string,
  reasonMinLength: _propTypes["default"].number,
  reasonMaxLength: _propTypes["default"].number,
  emptyReasonError: _propTypes["default"].string,
  invalidReasonLengthError: _propTypes["default"].string,
  reasonRegex: _propTypes["default"].instanceOf(RegExp),
  reasonRegexError: _propTypes["default"].string
};
ConfirmationModal.defaultProps = {
  isOpen: false,
  header: "Confirmation",
  secondaryMessage: "",
  cancelButtonText: "Cancel",
  continueButtonText: "Continue",
  className: "",
  size: "sm",
  // eslint-disable-next-line react/default-props-match-prop-types
  onContinue: function onContinue() {},
  // eslint-disable-next-line react/default-props-match-prop-types
  toggle: function toggle() {},
  bodyClassName: null,
  closeOnEscape: false,
  backdrop: "static",
  continueButtonType: "primary",
  dataTestId: "orion-confirmation-modal",
  confirmReasonRequired: false,
  reasonLabel: "Reason for deletion",
  reasonPlaceholder: "Please enter your comments here.",
  reasonMinLength: 10,
  reasonMaxLength: 150,
  emptyReasonError: "Please enter a reason.",
  invalidReasonLengthError: "Reason must be 10 to 150 characters long."
};
ConfirmationModal.displayName = "OrionConfirmationModal";
var _default = ConfirmationModal;
exports["default"] = _default;